const PartnersAccordian = (props) => {
  const { companyLogo, companyLogoAltText, companySummary, statistics } = props;
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-12 px-4 md:px-0 py-6 md:py-16 gap-6 border-t-2 border-white last:border-b-2 last:border-white">
        <div className="md:col-span-3 px-6">
          <img src={companyLogo} alt={companyLogoAltText} />
        </div>
        <div className="md:col-span-9 grid md:grid-cols-3 gap-4 text-grey gap-4">
          <div className="md:col-span-3 pb-8">
            <p>{companySummary}</p>
          </div>
          {statistics.map((item, index) => {
            return (
              <div key={index} className="md:col-span-1">
                <p dangerouslySetInnerHTML={{ __html: item }}></p>
              </div>
            )
          })}
        </div>
      </div>
    </>
  );
};

export default PartnersAccordian;